import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_table_action');

register('wm-table-action', (): IBuildTaskDef => {
    return {
        pre: (attrs: any) => {
          const counter = idGen.nextUid();
          return `<${tagName} name="${attrs.get('name') || attrs.get('key')}" wmTableAction #${counter}="wmTableAction" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
